import { takeEvery, put, call, select } from 'redux-saga/effects';
import { sendBillRegistration } from '../services/backendService';
import { namespaceActionObject } from './helpers'

// Type
export const REDUCER_ACTIONS = namespaceActionObject('PAYMENT')({
    BILL_REGISTRATION: 'BILL_REGISTRATION',
    BILL_REGISTRATION_COMPLETED: 'BILL_REGISTRATION_COMPLETED',
    BILL_REGISTRATION_IN_PROGRESS: 'BILL_REGISTRATION_IN_PROGRESS',
    BILL_REGISTRATION_ERROR: 'BILL_REGISTRATION_ERROR'
  })
  
  export const REDUCER_STATUS = {
    IN_PROGRESS : 'IN_PROGRESS',
    ERROR : 'ERROR',
    COMPLETED : 'COMPLETED'
  }

// actions

export const billRegistration = (token, encryptedCVV) => {
    return {
      type: REDUCER_ACTIONS.BILL_REGISTRATION,
      payload: { token, encryptedCVV }
    }
  }
  
  export const billRegistrationCompleted = () => {
    return {
      type: REDUCER_ACTIONS.BILL_REGISTRATION_COMPLETED,
    }
  }
  
  export const billRegistrationInProgress = () => {
    return {
      type: REDUCER_ACTIONS.BILL_REGISTRATION_IN_PROGRESS,
    }
  }
  
  export const billRegistrationError = (reason) => {
    return {
      type:  REDUCER_ACTIONS.BILL_REGISTRATION_ERROR,
      payload: { reason }
    }
  }

// SAGAS

export function* handleBillRegistration(action) {
    const { token, encryptedCVV } = action.payload;
    const authToken = yield select(getAuthToken)
    try {
      yield put(billRegistrationInProgress());
      yield call(sendBillRegistration, token, encryptedCVV, authToken);
      yield put(billRegistrationCompleted());
    } catch (error) {
      yield put(billRegistrationError(error));
    }
  }
  
  export function* watchBillRegistration() {
    yield takeEvery(REDUCER_ACTIONS.BILL_REGISTRATION, handleBillRegistration)
  }


  // STATE MAPPERS

  export const getAuthToken = (state) => state.auth.get('token');


export default (state= {}, action) => {
    switch (action.type){
        case REDUCER_ACTIONS.BILL_REGISTRATION_IN_PROGRESS:
            return { ...state , status: REDUCER_STATUS.IN_PROGRESS}
        case REDUCER_ACTIONS.BILL_REGISTRATION_ERROR:
            return { ...state, status: REDUCER_STATUS.ERROR, reason: action.reason }        
        case REDUCER_ACTIONS.BILL_REGISTRATION_COMPLETED:
            return { ...state, status: REDUCER_STATUS.COMPLETED, reason: action.reason }                     
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/billRegistration.js